// extracted by mini-css-extract-plugin
export default {"patchListTitle":"ProductPatchList_patchListTitle__PERY0"};